module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x2-8221f581949e891812b10281520d16cb.jpg";